<template>
  <div class="time">
    <p class="time1">{{ dateStr }}</p>
    <p class="time2">{{ timeStr }}</p>
  </div>
</template>

<script>
import dayjs from "dayjs";

export default {
  data() {
    return {
      dateStr: "",
      timeStr: "",
      clockTimer: null,
    };
  },
  mounted() {
    this.clockTimer = setInterval(() => {
      this.dateStr = dayjs().format("YYYY/MM/DD");
      this.timeStr = dayjs().format("HH:mm:ss");
    }, 1000);
  },
  beforeUnmount() {
    clearInterval(this.clockTimer);
  },
};
</script>

<style lang="scss" scoped>
.time {
  font-weight: 500;
  margin-left: 30px;
  margin-top: 10px;
  .time1 {
    font-size: 24px;
  }
  .time2 {
    font-size: 24px;
  }
}
</style>
